import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

const ForgotPassword: React.FC = () => {
  const { resetPassword } = useAuth();
  
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    try {
      setLoading(true);
      await resetPassword(email);
      setSent(true);
      toast.success('Password reset email sent!');
    } catch (error: any) {
      console.error('Password reset error:', error);
      
      if (error.code === 'auth/user-not-found') {
        toast.error('No account found with this email address');
      } else if (error.code === 'auth/invalid-email') {
        toast.error('Invalid email address');
      } else {
        toast.error('Failed to send password reset email');
      }
    } finally {
      setLoading(false);
    }
  };

    if (sent) {    return (      <div className="auth-page">        <div className="auth-container min-h-screen flex items-center justify-center px-8 relative">          {/* Animated dot background */}          <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />          <div className="max-w-md w-full animate-fade-up relative z-10">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={32} className="text-red-600" />
            </div>
            
            <h1 className="text-3xl font-display font-bold tracking-tight mb-4">
              Check your email
            </h1>
            
            <p className="text-primary-600 mb-8">
              We sent a password reset link to <strong>{email}</strong>
            </p>
            
            <div className="space-y-4">
              <Link to="/login" className="btn-primary w-full">
                Back to Sign In
              </Link>
              
              <button
                onClick={() => {
                  setSent(false);
                  setEmail('');
                }}
                className="btn-secondary w-full"
              >
                Try Different Email
              </button>
            </div>
            
            <p className="text-sm text-primary-600 mt-6">
              Didn't receive the email? Check your spam folder or try again.
            </p>
          </div>
                  </div>        </div>      </div>    );  }  return (    <div className="auth-page">      <div className="auth-container min-h-screen flex items-center justify-center px-8 relative">        {/* Animated dot background */}        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />        <div className="max-w-md w-full animate-fade-up relative z-10">
        {/* Back button */}
        <Link 
          to="/login"
          className="inline-flex items-center text-sm text-primary-600 hover:text-black transition-colors mb-8"
        >
          <ArrowLeft size={16} className="mr-2" />
          Back to sign in
        </Link>

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-display font-bold tracking-tight mb-2">
            Forgot password?
          </h1>
          <p className="text-primary-600">
            No worries, we'll send you reset instructions
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="label">Email</label>
            <div className="relative">
              <Mail size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-primary-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field pl-11"
                placeholder="Enter your email"
                disabled={loading}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? (
              <span className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </span>
            ) : (
              'Send Reset Instructions'
            )}
          </button>
        </form>

        {/* Sign up link */}
        <p className="text-center text-sm text-primary-600 mt-6">
          Don't have an account?{' '}
          <Link
            to="/signup"
            className="font-medium text-black hover:underline transition-colors"
          >
            Sign up
          </Link>
                </p>        </div>      </div>    </div>  );
};

export default ForgotPassword; 